import moment from 'moment';

const URL = import.meta.env.VITE_REACT_APP_API_BASE_URL;
const paths = {
  LoginUrl: `${URL}api/auth/login`,
  refreshTokenUrl: `${URL}api/auth/refresh-token`,
  changePasswordUrl: `${URL}api/auth/change/password`,
  forgotPasswordUrl: `${URL}api/auth/forgot`,
  inviteUserUrl: `${URL}api/auth/invite`,
  getAllUsersWithSearch(search, excludeSelf) {
    return `${URL}auth/users?search=${search}&excludeSelf=${excludeSelf}`;
  },
  confirmUser(inviteToken) {
    return `${URL}api/auth/accept/invite?inviteToken=${inviteToken}`;
  },
  listingUrlForScope: `${URL}auth/dataexplorer/filter`,
  pendingInvitesUrl: `${URL}auth/users/invited/all`,
  confirmInvitesUrl: `${URL}auth/users/confirmed/all`,
  deleteUserUrl(id) {
    return `${URL}auth/admin/deleteEmployee/${id}`;
  },
  resendInviteUrl(id) {
    return `${URL}api/auth/resend/invite/${id}`;
  },
  updateUserUrl(id) {
    return `${URL}auth/admin/updateEmployee/${id}`;
  },
  currentUser: `${URL}api/auth/profile`,
  updateLanguage: `${URL}auth/settings/language`,
  getAllUsersUrl: `${URL}auth/admin/allEmployees`,
  snapshotURL: `${URL}auth/dashboard`,
  initialSnapshotURL: `${URL}auth/dashboard`,
  filterListingURL: `${URL}auth/dashboard/filter`,
  trendURL: `${URL}auth/dashboard/trends`,
  initialTrendURL: `${URL}auth/dashboard/trends?entity_name[0]=demo&entity_name[1]=demo2&department_name[0]=Sales&department_name[1]=Marketing%20&%20Product&department_name[2]=Customer%20service&department_name[3]=HR%20department&department_name[4]=IT&department_name[5]=Finances&from=${new Date().getFullYear()}/01/01&to=${moment().format(
    'YYYY-MM-DD'
  )}`,
  filterListingUrlForDataExplorer: `${URL}auth/dataexplorer/filter`,
  dataExpolorerURL(data) {
    const { newDate } = data;
    const { currentDate } = data;
    const { Metrics } = data;
    const { X_Axis: xAxis } = data;
    const Groupby = data.groupby;
    const entity = data?.entity.map((name, i) => `entity_name[${i}]=${name}&`).join('');
    const department = data?.department.map((name, i) => `department_name[${i}]=${name}&`).join('');
    const sort = data?.sort;
    return `${URL}auth/dataexplorer/?metric=${Metrics}&x_axis=${xAxis}&groupby=${Groupby}&from=${newDate}&to=${currentDate}&sort=${sort}&${entity}${department}`;
  },
  dataExplorerPieChartURL(data) {
    const { newDate } = data;
    const { currentDate } = data;
    const { Metrics } = data;
    const Groupby = data.groupby;
    const entity = data?.entity.map((name, i) => `entity_name[${i}]=${name}&`).join('');
    const department = data?.department.map((name, i) => `department_name[${i}]=${name}&`).join('');
    const sort = data?.sort;

    return `${URL}auth/dataexplorer/?metric=${Metrics}&x_axis=Days&groupby=${Groupby}&from=${newDate}&to=${currentDate}&sort=${sort}&${entity}${department}&pieChart=true`;
  },
  basicAdvAnalyticsURL(data) {
    const { newDate } = data;
    const { currentDate } = data;
    const entity = data?.entity.map((name, i) => `entity_name[${i}]=${name}&`).join('');
    return `${URL}auth/dashboard/employees_data?&${entity}&from=${newDate}&to=${currentDate}`;
  },
  goFurtherAdvAnalyticsURL(data) {
    const { newDate } = data;
    const { currentDate } = data;
    const entity = data?.entity.map((name, i) => `entity_name[${i}]=${name}&`).join('');
    return `${URL}auth/gofurther?&${entity}&from=${newDate}&to=${currentDate}`;
  },
  SummaryAdvAnalyticsURL(data) {
    const newDate = data?.newDate;
    const currentDate = data?.currentDate;
    const entity = data?.entity.map((name, i) => `entity_name[${i}]=${name}&`).join('');
    const { lang } = data;
    return `${URL}auth/gofurther/insightSummary?&${entity}&from=${newDate}&to=${currentDate}&lang=${lang}`;
  },

  searchEmployees(companyId, page, sort, searchQuery = '', limit) {
    return `${URL}auth/employees/search/${companyId}?page=${page}&search=${encodeURIComponent(searchQuery)}&sort=${sort}&limit=${limit}`;
  },
  employeeCount(companyId) {
    return `${URL}auth/employees/count/${companyId}`;
  },
  activeEmployeesCount(companyId) {
    return `${URL}auth/employees/active/${companyId}`;
  },
  womenEmployeesCount(companyId) {
    return `${URL}auth/employees/women/${companyId}`;
  },
  averageAge(companyId) {
    return `${URL}auth/employees/average-age/${companyId}`;
  },
  averageTenure(companyId) {
    return `${URL}auth/employees/average-tenure/${companyId}`;
  },
  distinctContractStatuses(companyId) {
    return `${URL}auth/employees/contract-statuses/${companyId}`;
  },
  distinctMaritalStatuses(companyId) {
    return `${URL}auth/employees/marital-statuses/${companyId}`;
  },
  getEmployeesFilters: `${URL}auth/employees/filters`,
  distinctContractTypes: `${URL}auth/employments/contract-types`,
  entityNames: `${URL}auth/company/entity-names`,
  getEntitiesWithDepartments: `${URL}auth/company/entities-with-departments`,
  onboardData() {
    return `${URL}auth/overview/onboard`;
  },
  offboardData() {
    return `${URL}auth/overview/offboards`;
  },
  turnoverData() {
    return `${URL}auth/overview/turnover`;
  },
  attritionData() {
    return `${URL}auth/overview/attrition`;
  },

  totalCompensation(companyId) {
    return `${URL}auth/pay/total-compensation/${companyId}`;
  },
  averageCompensation(companyId) {
    return `${URL}auth/pay/average-compensation/${companyId}`;
  },
  genderPayGap(companyId) {
    return `${URL}auth/pay/gender-pay-gap/${companyId}`;
  },
  exportPayroll(companyId, sort) {
    return `${URL}auth/pay/export-payroll/${companyId}?&sort=${sort}`;
  },
  employeesPayroll(companyId, page, sort, searchQuery = '') {
    return `${URL}auth/pay/employees-payroll/${companyId}?page=${page}&search=${encodeURIComponent(searchQuery)}&sort=${sort}`;
  },
  exportEmployees(companyId, sort) {
    return `${URL}auth/employees/export-employees/${companyId}?&sort=${sort}`;
  },
  overviewWorkforce() {
    return `${URL}auth/overview/workforce`;
  },
  overviewDiversity() {
    return `${URL}auth/overview/diversity`;
  },
  employeesFieldsData(companyId) {
    return `${URL}auth/data-quality/employees/fields/${companyId}`;
  },
  employeesMissingData(companyId, field, page = 1, limit = 30) {
    return `${URL}auth/data-quality/employees/${companyId}?field=${field}&page=${page}&limit=${limit}`;
  },
  payrollFieldsData(companyId) {
    return `${URL}auth/data-quality/payroll/fields/${companyId}`;
  },
  payrollMissingData(companyId, field, page = 1, limit = 30) {
    return `${URL}auth/data-quality/payroll/${companyId}?field=${field}&page=${page}&limit=${limit}`;
  },
  exportOverview: `${URL}auth/dashboard/send-overview`,
  chatbotAnswerUrl: `${URL}auth/chatbot`,
  getGraphParamsByID(graphId) {
    return `${URL}auth/graphs/${graphId}`;
  },
  getGraphData() {
    return `${URL}auth/graphs`;
  },
  graphLockFilters: (id) => `${URL}auth/graphs/${id}/lock-filters`,
  overviewPeopleFlow() {
    return `${URL}auth/overview/peopleFlow`;
  },
  customDashboardsURL: `${URL}auth/custom-dashboards`,
  userDashboardsURL: `${URL}auth/custom-dashboards/user`,
  templateCategoriesURL: `${URL}auth/custom-dashboards/categories`,
  categoryTemplatesURL(categoryId) {
    return `${URL}auth/custom-dashboards/categories/${categoryId}`;
  },
  createDashboardAndAddGraphsURL: `${URL}auth/custom-dashboards/from-template`,
  domainsURL: `${URL}auth/domains`,
  domainUrlWithId(domainId) {
    return `${URL}auth/domains/${domainId}`;
  },
  userDomainsURL(userId) {
    return `${URL}auth/domains/user/${userId}`;
  },
  getUserPermissions: (permissionType = '') => {
    const queryString = permissionType ? `?permissionType=${permissionType}` : '';
    return `${URL}auth/permissions/user-permissions${queryString}`;
  },
  removeGraphByIndex(dashboardId, graphIndex) {
    return `${URL}auth/custom-dashboards/${dashboardId}/graph/${graphIndex}`;
  },
  graphById(graphId) {
    return `${URL}auth/graphs/${graphId}`;
  },
  graphTitleById(graphId) {
    return `${URL}auth/graphs/title/${graphId}`;
  },
  addGraphToDashboard: `${URL}auth/custom-dashboards/addGraphs`,
  customDashboardById(dashboardId) {
    return `${URL}auth/custom-dashboards/${dashboardId}`;
  },
  overviewRecruitment() {
    return `${URL}auth/overview/recruitment`;
  },
  overviewLearning() {
    return `${URL}auth/overview/learning`;
  },
  overviewCompensation() {
    return `${URL}auth/overview/compensation`;
  },
  overviewAbsenteeism() {
    return `${URL}auth/overview/absenteeism`;
  },
  employeesCustomAttributesURL: `${URL}auth/employees-attributes`,
  customDashboardFilter: `${URL}auth/custom-dashboards/filters/all`,
  tenureData() {
    return `${URL}auth/overview/tenure`;
  },
  sharedDashboardsURL: `${URL}auth/custom-dashboards/shared/withme`,
  OverviewFilters: `${URL}auth/overview/filters/all`,
  getInsightsURL: `${URL}auth/graphs/insights`,
  dashboardSharedWithURL(dashboardId) {
    return `${URL}auth/custom-dashboards/shared/with/${dashboardId}`;
  },
  searchDomainUserListURL(search) {
    return `${URL}auth/users/domain?search=${search}`;
  },
  shareDashboardURL(dashboardId, recipientId) {
    return `${URL}auth/custom-dashboards/share/${dashboardId}/${recipientId}`;
  },
  updateRoleInSharedDashboardURL(dashboardId, recipientId) {
    return `${URL}auth/custom-dashboards/role/${dashboardId}/${recipientId}`;
  },
  removeShareDashboardAccessURL(dashboardId, recipientId) {
    return `${URL}auth/custom-dashboards/share/${dashboardId}/${recipientId}`;
  },
  duplicateSharedDashboardURL(dashboardId) {
    return `${URL}auth/custom-dashboards/duplicate/shared/${dashboardId}`;
  },
  getGraphParamsFromPrompt(prompt, threadId) {
    return `${URL}auth/graphs/generate?prompt=${prompt}&threadId=${threadId}`;
  },
  getPayrollFilters: `${URL}auth/pay/filters`,
  getRoles: `${URL}auth/roles`,
  groupBys({ metric, subMetric, chartType }) {
    return `${URL}auth/constants/groupbys?metric=${metric}&subMetric=${subMetric}&chartType=${chartType}`;
  },
  getSavedFilter: `${URL}auth/saved-filters`,
  dataAccessListURL: `${URL}auth/constants/data-access`,
  moduleAccessListURL: `${URL}auth/constants/module-access`,
  chartTypes() {
    return `${URL}auth/constants/chart-types`;
  },
  DateRanges() {
    return `${URL}auth/constants/date-ranges`;
  },
  getAxisOptions({ metric, subMetric, chartType }) {
    return `${URL}auth/constants/xaxis-options?metric=${metric}&subMetric=${subMetric}&chartType=${chartType}`;
  },
  metricOptions({ chartType }) {
    return `${URL}auth/constants/metrics?chartType=${chartType}`;
  },
  employeesAttributesHealthcheck(module) {
    return `${URL}auth/employees-attributes/healthcheck/${module}`;
  },
  employeesAttributesDataQuality() {
    return `${URL}auth/data-quality`;
  },
  getDashboardInsightsURL: `${URL}auth/graphs/insights/dashboard`,
  getIndexMWInsightsURL: `${URL}auth/legal-hub/insights/indexmw`,
  employeesWithMissingData(fieldName, page = 1, limit = 5) {
    return `${URL}auth/data-quality/fields/${fieldName}/details?page=${page}&limit=${limit}`;
  },
  getAttributeLabels() {
    return `${URL}auth/constants/attributes-label`;
  },
  employeesDetails(id) {
    return `${URL}auth/employees/${encodeURIComponent(id)}`;
  },
  orgChart(id, isPeopleHub) {
    return `${URL}auth/employees/${encodeURIComponent(id)}/organization?isPeopleHub=${isPeopleHub}`;
  },
  getDashboardComments(dashboardId, filters) {
    if (!dashboardId) return `${URL}auth/comments`;

    const params = new URLSearchParams({
      dashboardId,
      ...filters,
    });

    return `${URL}auth/comments?${params.toString()}`;
  },
  updateComment(commentId) {
    return `${URL}auth/comments/${commentId}`;
  },
  deleteComment(commentId) {
    return `${URL}auth/comments/${commentId}`;
  },
  comparisonData(id) {
    return `${URL}auth/employees/${encodeURIComponent(id)}/comparison`;
  },
  peopleHubOrgChart() {
    return `${URL}auth/employees/orgchart`;
  },
  createReport: `${URL}auth/reports`,
  getReports: `${URL}auth/reports`,
  deleteReport(reportId) {
    return `${URL}auth/reports/${reportId}`;
  },
  updateReport(reportId) {
    return `${URL}auth/reports/${reportId}`;
  },
  getReportById(reportId) {
    return `${URL}auth/reports/${reportId}`;
  },
  updateSection(sectionId) {
    return `${URL}auth/sections/${sectionId}`;
  },
  updateSectionContent(contentId) {
    return `${URL}auth/contents/${contentId}`;
  },
  deleteSection(sectionId) {
    return `${URL}auth/sections/${sectionId}`;
  },
  deleteSectionContent(contentId) {
    return `${URL}auth/contents/${contentId}`;
  },
  addSection() {
    return `${URL}auth/sections/createSection`;
  },
  getFavoriteDashboards: `${URL}auth/custom-dashboards/my/favorites`,
  addToFavorites(id) {
    return `${URL}auth/custom-dashboards/favorite/${encodeURIComponent(id)}`;
  },
  removeToFavorites(id) {
    return `${URL}auth/custom-dashboards/favorites/${encodeURIComponent(id)}`;
  },
  getFavoritesList: `${URL}auth/custom-dashboards/my/favorites`,
  getConversationsData: `${URL}auth/comments/mentioned/me`,
  getRecentlyViewedList: `${URL}auth/views/custom-dashboard`,
  getBdeseComments(reportId, filters) {
    if (!reportId) return `${URL}auth/bdeseComments`;

    const params = new URLSearchParams({
      reportId,
      ...filters,
    });

    return `${URL}auth/bdeseComments?${params.toString()}`;
  },
  deleteBdeseComment(commentId) {
    return `${URL}auth/bdeseComments/${commentId}`;
  },
  updateBdeseComment(commentId) {
    return `${URL}auth/bdeseComments/${commentId}`;
  },
  shareReportURL(reportId, recipientId) {
    return `${URL}auth/reports/share/${reportId}/${recipientId}`;
  },
  reportSharedWithURL(reportId) {
    return `${URL}auth/reports/shared/with/${reportId}`;
  },

  updateRoleInSharedBdeseURL(reportId, recipientId) {
    return `${URL}auth/reports/role/${reportId}/${recipientId}`;
  },

  removeShareReportAccessURL(reportId, recipientId) {
    return `${URL}auth/reports/share/${reportId}/${recipientId}`;
  },
  recordDashboardView(dashboardId) {
    return `${URL}auth/views/custom-dashboard/${dashboardId}`;
  },
  getEnv() {
    return `${URL}auth/env`;
  },
  exportAsPdf(dashboardId) {
    return `${URL}auth/custom-dashboards/${encodeURIComponent(dashboardId)}/export/pdf`;
  },
  getChartConfig() {
    return `${URL}auth/constants/chart-config`;
  },
  groupByMapping: `${URL}auth/constants/groupby-mapping`,
  createSchedule: (dashboardId) => `${URL}auth/schedule/dashboard/${dashboardId}`,
  getSchedulesByDashboard: (dashboardId) => `${URL}auth/schedule/dashboard/${dashboardId}`,
  getScheduleById: (scheduleId) => `${URL}auth/schedule/${scheduleId}`,
  updateSchedule: (scheduleId) => `${URL}auth/schedule/update/${scheduleId}`,
  runScheduleNow: (scheduleId) => `${URL}auth/schedule/${scheduleId}/run-now`,
  pauseSchedule: (scheduleId) => `${URL}auth/schedule/${scheduleId}/pause`,
  resumeSchedule: (scheduleId) => `${URL}auth/schedule/${scheduleId}/resume`,
  getAllColorTemplates: () => `${URL}auth/graphs/color-templates/all`,
  getColorTemplateById: (templateId) => `${URL}auth/graphs/color-templates/${templateId}`,
  createColorTemplate: () => `${URL}auth/graphs/color-templates`,
  updateColorTemplate: (templateId) => `${URL}auth/graphs/color-templates/${templateId}`,
  deleteColorTemplate: (templateId) => `${URL}auth/graphs/color-templates/${templateId}`,
  attributesTranslate: `${URL}auth/attribute-labels/translate`,
  attributesLabels: `${URL}auth/attribute-labels`,
  resetAttributeLabels: `${URL}auth/attribute-labels/reset`,
  defaultFilterAttributes() {
    return `${URL}auth/constants/default-filter-attributes`;
  },
  processTableData: `${URL}auth/graphs/process-table-data`,
};

export default paths;
